import React from 'react';
import PropTypes from 'prop-types';

import { DonutNew } from 'components/common/charts/charts';

import { LegendStatus } from 'components/common/charts/parts/parts';
import { Heading } from '../../Elements/Elements';

import classes from './DonutColors.module.scss';

const DonutColors = ({ chartData }) => {
  const { title, data, chartColor } = chartData;
  return (
    <section className={classes.box}>
      <Heading>{title}</Heading>
      <div className={classes.body}>
        <DonutNew data={data} chartColor={chartColor} />
        <LegendStatus
          legendData={data}
          chartColor={chartColor}
          legendBigMargin
        />
      </div>
    </section>
  );
};

DonutColors.propTypes = {
  chartData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    chartColor: PropTypes.object
  })
};

export default DonutColors;
